import { format, parseISO } from "date-fns"

import { ukDateOf, ukTimeOf } from "../../../shared/shift-timing.ts"

export const driversText = (count: number) => (count === 1 ? "1 driver" : `${count} drivers`)

// In UK time, whatever the browser's zone.
export const ukDateTimeText = (timestamp: string) => {
  const at = new Date(timestamp)
  return `${format(parseISO(ukDateOf(at)), "EEE d MMM")} at ${ukTimeOf(at)}`
}
